// angular
import {Component, ElementRef, OnInit, OnDestroy} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

// services
import { SelfEvaluationService } from '../self-evaluation.service';
import { AuthService } from '../../core/auth.service';

// others
import { SelectionComponent } from '../selection.component';
import { AppService } from '../../app.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { CoreService } from '../../core/core.service';

declare var window:any;

@Component({
    templateUrl: 'circumstance.component.html',
    styleUrls: ['../self-evaluation.component.scss']
})
export class CircumstanceComponent extends SelectionComponent implements OnInit, OnDestroy {
    apiRoute: string;
    error = '';

    constructor(
        public elementRef: ElementRef,
        public service: SelfEvaluationService,
        public router: Router,
        public route: ActivatedRoute,
        public authService: AuthService,
        public appService: AppService,
        public coreService: CoreService,
        public translateService : TranslateService
    ) {
        super(elementRef, service, router, route, authService, appService, coreService, translateService);
    }

    ngOnInit() {
        this.initStartTime();
        this.nextStep = false;
        this.noBackPlease();
        window.onbeforeunload = this.popupReload;
        window.onkeydown = this.preventBack;
        this.deviceInnerHeight = this.appService.deviceInnerHeight;
        this.lang = this.translateService.currentLang;
        this.setSEType();
        this.apiRoute = this.pageTypes[this.appService.SEType]['circumstanceRoute'] + '/';

        this.currentStep = this.appService.getCurrentSeStep();
        this.route.params.subscribe(params => {
            this.token = params['token'];
            this.appService.isLoading = true;
            const apiRoute = this.apiRoute + this.token + '/' + this.itemPerPage;

            this.service.getItems(apiRoute).subscribe((rs) => {
                this.isStudy = rs['is_study'];
                this.currentStep = rs['step'] || this.currentStep;
                this.appService.setCurrentSeStep(this.currentStep);
                this.questionnaireId = rs['patient_questionnaire_id'];
                this.itemsGroup = rs['items'] || [];
                this.selectedIds = rs['selected_ids'];
                this.groupSelectedCount[this.activePage] = this.calculateSelectedItem(this.selectedIds);

                //1464
                this.appService.isLoading = false;

                //2157
                super.listenPatientChange(this.questionnaireId, this.token);
                
                return this.scrollToTop();
            },
            error => {
                this.error = JSON.stringify(error);
                this.appService.isLoading = false;
            });
        });

        this.subscription = this.translateService.onLangChange.subscribe(value => {
            this.lang = value.lang;
            let data = {
                'questionnaire_id' : this.questionnaireId,
                'language' : value.lang
            };

            this.isLoading = true;
            this.service.changeLanguage(data).subscribe(language => {
                this.isLoading = false;
            });
        });

    }

    ngOnDestroy() {
       super.ngOnDestroy();
    }

    submitSelection(goNextStep = 0, cb: any = false) {
        this.isLoading = true;
        const selectedIds = this.selectedIds;
        // If: Repeated SE
        let selectedCircumstanceIds = this.selectedCircumstanceIds;

        this.itemsGroup.forEach(function (group) {
            group.forEach(function (item) {
                if (selectedIds.indexOf(item['id']) < 0 && selectedCircumstanceIds.indexOf(item['id']) < 0) {
                    return;
                }
            });
        });
        // End If
        this.service.submit(this.apiRoute + 'update?', {
            // smoke_detectors: (this.appService.SEType === this.pageTypes.repeatedSE.type) ? selectedCircumstanceIds : selectedIds,
            feelings: selectedIds,
            is_finish: goNextStep,
            token: this.token,
            step: this.currentStep,
            next_item : (this.itemPerPage * this.activePage) + 1
        }).subscribe((rs) => {

            if (rs['success'] && goNextStep) {
                this.stepNavigate(0);
            }
            this.isLoading = false;

            if (typeof cb === 'function') {
                cb();
            }
        });
    }
}
